import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { _programid } from '../RecoilState';
import axios from 'axios';
import Loader from '../components/Loader';
import Youtubeembed from '../components/Youtubeembed';
import DOMPurify from 'dompurify';
import '../components/components.css'

const ProgramDetails = () => {
    const { pslug } = useParams(); // Access the parameter as 'pageSlug'
    const [programid, setProgramid] = useRecoilState(_programid);
    const [loading, setLoading] = useState(true);
    const [programdetails, setProgramdetails] = useState({})
    const [excerpt, setExcerpt] = useState()
    const [link, setLink] = useState("")

    const navigate = useNavigate();

    useEffect(() => {
        // console.log(pslug)
        // console.log(programid);
        getProgramdata()
    }, [])

    const buyNow = () => {
        console.log(link)
        // navigate(link)
        window.location.href = link;
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        }, 700);
    }

    const getProgramdata = () => {
        axios.get(`/programs?slug=${pslug}`)
            // axios.get(`/programs/74`)
            .then((response) => {
                console.log(response.data[0])
                setProgramdetails(response.data[0])
                setLink(response.data[0].acf.buy_link_program)
                setLoading(false)
            })
    }

    // const cleanHTML = DOMPurify.sanitize(programdetails.acf.short_excerpt_program);

    return (
        <div>
            {
                loading ? <Loader />
                    :
                    <>
                        {/* page heading */}
                        <div className='spacer'>
                            <p className='brand-text large-gradient-heading'>{programdetails.title.rendered}</p>
                        </div>

                        {/* program excerpt */}
                        <div className='spacer'>
                            {/* <p className='brand-text txt-survey'>{excerpt}</p> */}
                            <div className='html_text_block brand-text txt-survey' dangerouslySetInnerHTML={{ __html: programdetails.acf.short_excerpt_program }} />
                        </div>

                        {/* yt video embed */}
                        <div className='spacer'>
                            <Youtubeembed videourl={programdetails.acf.yt_video_url_program} />
                        </div>

                        {/* price and highlight section */}
                        <div className='grid grid-cols-2 gap-2 spacer'>
                            <div>
                                {/* price card */}
                                <div className='border-solid border-gray border-[1px] rounded p-2 h-full'>
                                    <div className='shiny-box'>
                                        <p className='border15px sub-heading brand-font h-1/3'>Program Price</p>

                                        <div className='flex flex-row test justify-between h-2/3 bottom7px'>
                                            <div className='flex flex-col justify-center'>
                                                <p className='brand-font text-left bottom15px'>₹</p>
                                            </div>
                                            <div className='flex flex-col justify-end'>
                                                <p className='brand-text leading-[50px] text-[50px] text-right special-gradient-size large-gradient-heading'>{programdetails.acf.cost_program}</p>
                                                <p className='brand-font text-[16px] text-right'>only</p>
                                            </div>
                                        </div>
                                        <div className='bottom15px'>
                                            <p className='brand-font text-[12px] text-center'>+ taxes as applicable</p>
                                        </div>

                                        <div className='flex h-1/2 justify-center'>
                                            {
                                                (link === "") ?
                                                    <button disabled className='p-4 rounded bg-gray-300' onClick={() => buyNow()}>
                                                        <p className='txt brand-font'>Coming Soon</p>
                                                    </button>
                                                    :
                                                    <button
                                                        className='rotating-border-button'
                                                        onClick={() => buyNow()}>
                                                        <p className='small-heading brand-font'>
                                                            BUY NOW
                                                        </p>
                                                    </button>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col gap-2'>
                                {
                                    programdetails.acf.highlights_program.map(prog => (
                                        <div className='border-solid border-gray border-[1px] rounded p-2 flex-grow flex items-center'>
                                            <p className='brand-font text-[16px] p-1'>{prog.highlight_program}</p>
                                        </div>
                                    ))
                                }
                            </div>


                        </div>

                        {/* requirements */}
                        <div className='spacer'>
                            <p className='brand-text bottom7px txt-heading-large'>Requirements :</p>
                            <ul>
                                {
                                    programdetails.acf.requirements_program.map(prog => (
                                        <li className='brand-text txt py-1'>✨ {prog.requirement_program}</li>
                                    ))
                                }
                            </ul>
                        </div>

                        {/* contents */}
                        <div className='spacer'>
                            <p className='brand-text bottom7px txt-heading-large'>What do you get ?</p>
                            <ul>
                                {
                                    programdetails.acf.contents_program.map(prog => (
                                        <li className='brand-text txt py-1'>✨ {prog.content_program}</li>
                                    ))
                                }
                            </ul>
                        </div>

                        {/* objectives */}
                        <div className='spacer'>
                            <p className='brand-text bottom7px txt-heading-large'>Program Objectives :</p>
                            <ul>
                                {
                                    programdetails.acf.objectives_program.map(prog => (
                                        <li className='brand-text txt py-1'>✨ {prog.objective_program}</li>
                                    ))
                                }
                            </ul>
                        </div>

                        {/* topics */}
                        <div className='spacer'>
                            <p className='brand-text bottom7px txt-heading-large'>Contents :</p>
                            <ul>
                                {
                                    programdetails.acf.topics_program.map(prog => (
                                        <li className='brand-text txt py-1'>✨ {prog.topic_program}</li>
                                    ))
                                }
                            </ul>
                        </div>

                    </>
            }
        </div>
    )
}

export default ProgramDetails